import { callable } from './functions';

export const uploadOrgLogo = callable<{ orgId: string; dataUrl: string }, { url: string }>('uploadOrgLogo');

export const getOrgLogoUrl = callable<{ orgId: string }, { url: string | null }>('getOrgLogoUrl');
